// extracted by mini-css-extract-plugin
export default {"contentLeft":"stickyComponent_contentLeft__5xG7p","border":"stickyComponent_border__MgUiz","period":"stickyComponent_period__pgDJd"};